import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CustomResultOfPaginatedListOfBankOnlineGatewayWithPaginationDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BankOnlineGatewayDto } from './../../../core/api/models/bank-online-gateway-dto';
import { BankOnlineGatewayWithPaginationDto } from './../../../core/api/models/bank-online-gateway-with-pagination-dto';
import { GetEnumValuesDto } from './../../../core/api/models/get-enum-values-dto';
import { PaginatedListOfBankOnlineGatewayWithPaginationDto } from './../../../core/api/models/paginated-list-of-bank-online-gateway-with-pagination-dto';
import { BankOnlineGatewaysService } from './../../../core/api/services/bank-online-gateways.service';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { BankOnlineGatewaysFormComponent } from "./bank-online-gateways-form/bank-online-gateways-form.component";

@Component({
    selector: 'app-bank-online-gateways',
    templateUrl: './bank-online-gateways.component.html',
    imports: [BaseIndexModule, BankOnlineGatewaysFormComponent],
    styles: [
        `
      pre {
        overflow: hidden;
        font-size: 14px;
      }
    `,
    ]
})
export class BankOnlineGatewaysComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.bankOnlineGateways;

  /* Binding service endpoints */
  protected currentService = inject(BankOnlineGatewaysService);
  paginationApiMethodName: string =
    this.currentService.bankOnlineGatewaysGetBankOnlineGatewaysWithPagination.name;
  createGetApiMethodName: string =
    this.currentService.bankOnlineGatewaysCreateGet.name;
  auditApiMethodName: string =
    this.currentService.bankOnlineGatewaysGetBankOnlineGatewaysAudit.name;
  deleteApiMethodName: string =
    this.currentService.bankOnlineGatewaysDelete.name;

  modelWithPagination$: Observable<PaginatedListOfBankOnlineGatewayWithPaginationDto>;
  items$: Observable<Array<BankOnlineGatewayWithPaginationDto>>;
  formPageConfig: FormPageConfig<BankOnlineGatewayDto> = {};

  TypeIpGsEnumValues: GetEnumValuesDto[] = [];
  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('TypeIPGs')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.TypeIpGsEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: `${this.tableVocabs}accountInformationId`,
        name: 'accountInformationAccountNo',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: `${this.tableVocabs}accountInformationOwner`,
        name: 'accountInformationOwner',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}typeIPG`,
        name: 'typeIPG',
        hasSearch: true,
        type: 'enum',
        enumName: 'TypeIPGs',
      },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}isGeneralUse`,
        name: 'isGeneralUse',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}isFactorUse`,
        name: 'isFactorUse',
        type: 'boolean',
        hasSearch: true,
      },
      { title: `${this.tableVocabs}configJson`, name: 'configJson' },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api


  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .bankOnlineGatewaysUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion

  onDelete(id: any, accountInformationOwner: any, typeIPG: any) {
    const dialogResult = this.getConfirmDialog({
      content: `  ( ${
        this.TypeIpGsEnumValues.find((a) => a.key == typeIPG)?.value
      })
      ${accountInformationOwner}`,

      isConfirmDelete: true,
      confirmByWritingText: false,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.pageConfig.loading = true;
          this.baseDeleteApi(id);
        }
      });
  }
}
